const my_profile = {
  viewMyClubSeacretProfile: "Δείτε το προφίλ μου ClubSeacret", // translated
  viewMoreDetails: "Δείτε περισσότερες λεπτομέρειες", // translated
  verifiedEmail: "Επαληθευμένο email", // translated
  unverifiedEmail: "Μη επαληθευμένο email", // translated
  createdFrom: "Δημιουργήθηκε από", // translated
  createdTo: "Δημιουργήθηκε έως", // translated
  selectStatus: "Επιλέξτε κατάσταση...", // translated
  searchByTitle: "Αναζήτηση με τίτλο...", // translated
};

export default my_profile;
